import { LocaleApi } from '@rbx/clients/locale';
import { Configuration } from '@rbx/clients';
import { getBEDEV1ServiceBasePath } from '@modules/utilities/constants/baseUrl';
import { stringToLocale } from '@modules/localization/utils/localeUtils';

export class LocaleClient {
  private localeApi: LocaleApi;

  constructor(basePath: string = getBEDEV1ServiceBasePath('locale')) {
    const defaultConfig = new Configuration({
      basePath,
      credentials: 'include',
    });

    this.localeApi = new LocaleApi(defaultConfig);
  }

  async getCreatorHubLocale() {
    const { signupAndLogin } =
      await this.localeApi.v1LocalesUserLocalizationLocusSupportedLocalesGet();
    if (signupAndLogin?.locale) {
      return stringToLocale(signupAndLogin?.locale?.replace('_', '-'));
    }
    return undefined;
  }
}

const localeClient = new LocaleClient();
export default localeClient;
